export enum VerantosOrgEnum {
  VERANTOS = 'Verantos',
}
